// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UZvq","fullView":"styles_fullView__1w15I"};